import type { i18n as I18nType } from '@wix/fe-essentials/i18n';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const SUPPORTED_LOCALES = [
  'ar',
  'bg',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'fi',
  'fr',
  'he',
  'hi',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'lt',
  'ms',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sv',
  'th',
  'tl',
  'tr',
  'uk',
  'vi',
  'zh',
];

export const FORM_VIEWER_NAMESPACE = 'form-viewer';

async function loadFieldViewerTranslations(locale: string) {
  try {
    const supportedLocale = SUPPORTED_LOCALES.includes(locale) ? locale : 'en';
    const fieldMessages = await import(
      `@wix/form-fields/dist/esm/assets/locale/viewer/messages_${supportedLocale}.json`
    );
    return fieldMessages.default;
  } catch (error) {
    console.warn(
      `Failed to load translations for locale ${locale}, falling back to English`,
      error,
    );

    try {
      const fallbackMessages = await import(
        `@wix/form-fields/dist/esm/assets/locale/viewer/messages_en.json`
      );
      return fallbackMessages.default;
    } catch {
      return {};
    }
  }
}

export async function createI18n(locale: string): Promise<I18nType> {
  const i18nInstance = i18next.createInstance();

  await i18nInstance.use(initReactI18next).init({
    lng: locale,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    keySeparator: false,
    nsSeparator: ':',
    defaultNS: 'translation',
    ns: ['translation', FORM_VIEWER_NAMESPACE],
    resources: {},
  });

  const fieldTranslations = await loadFieldViewerTranslations(locale);

  i18nInstance.addResourceBundle(
    locale,
    FORM_VIEWER_NAMESPACE,
    fieldTranslations,
    true,
    true,
  );

  return i18nInstance as unknown as I18nType;
}
